import { ReactNode } from "react";

export interface PanelFooterProps {
  /**
   * Content to render in the footer
   */
  children: ReactNode;

  /**
   * Optional additional class name
   */
  className?: string;

  /**
   * Optional justification for the footer content
   * @default "between"
   */
  justify?: "start" | "end" | "center" | "between" | "around" | "evenly";

  /**
   * Whether to include the top border
   * @default true
   */
  withBorder?: boolean;

  /**
   * Optional padding override
   * @default "p-4"
   */
  padding?: string;
}

/**
 * Static mapping of justify prop values to Tailwind classes
 * Using direct class names instead of string interpolation ensures
 * that PurgeCSS will not remove these utility classes in production
 */
const justifyClassMap = {
  start: "justify-start",
  end: "justify-end",
  center: "justify-center",
  between: "justify-between",
  around: "justify-around",
  evenly: "justify-evenly",
};

export const PanelFooter = ({
  children,
  className = "",
  justify = "between",
  withBorder = true,
  padding = "p-4",
}: PanelFooterProps) => {
  return (
    <div
      className={`flex ${justifyClassMap[justify]} ${padding} ${
        withBorder ? "border-t border-secondary-200" : ""
      } bg-background ${className}`}
    >
      {children}
    </div>
  );
};
